import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { getProjectLogoUri, getOrganizationId } from "common/selectors";
import AppBar from "@material-ui/core/AppBar";
import { path, pipe } from "ramda";
import { getProject } from "../../application/applicationReducer";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useStyles = (projectLogoUri, organizationLogoUri) =>
  makeStyles(theme => ({
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: "100%",
      },

      marginBottom: 20,
    },

    logos: {
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(3),
    },

    logoLeft: {
      width: 264,
      height: 110,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center left",
      backgroundImage: `url(${projectLogoUri})`,
    },

    logoRight: {
      width: 264,
      height: 110,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center right",
      backgroundImage: `url(${organizationLogoUri})`,
    },

    visuallyHidden: {
      position: "absolute",
      width: 1,
      height: 1,
      margin: -1,
      padding: 0,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      border: 0,
      whiteSpace: "nowrap" /* Prevents text from wrapping */,
    },
  }));

const SubmissionPanelHeader = () => {
  const project = useSelector(pipe(path(["application"]), getProject));
  const projectLogoUri = useSelector(getProjectLogoUri);
  const organizationId = useSelector(getOrganizationId);
  const [organizationUrl, setOrganizationUrl] = useState(null);

  useEffect(() => {
    setOrganizationUrl(
      `${API_BASE_URL}/organizations/${organizationId}/assets/branding.png`
    );
  }, [organizationId]);

  const classes = useStyles(projectLogoUri, organizationUrl)();

  return (
    <AppBar position="relative" elevation={0} className={classes.appBar}>
      <div className={classes.logos}>
        <div className={classes.logoLeft} />
        {organizationId && <div className={classes.logoRight} />}
        {/* Need H1 tag for screen readers */}
        <h1 className={classes.visuallyHidden}>
          {project?.projectName ?? "Custom Submission Page for BiblioBoard"}
        </h1>
      </div>
    </AppBar>
  );
};

export default SubmissionPanelHeader;
